<template>
  <div class="forgot_password_page">
    <div class="page_header">
      <div class="logo">
        <img src="../../assets/logo.png" alt="">
      </div>
    </div>

    <div class="page_title">
      パスワード再設定
    </div>

    <div class="forgot_password_form">
      <p>
        パスワード再設定用のURLを送るメールアドレスを入力してください。
      </p>

      <input v-validate="'required|email'" name="form_email" type="email" v-model="email" placeholder="メールアドレス">
      <div class="vee-validate-message">{{ errors.first('form_email') }}</div>

      <a href="javascript:void(0)" class="button deep_blue block mb-1 mt-6" @click="handleClickResetPassword">送信</a>
      <router-link :to="{name: 'login'}" href="javascript:void(0)" class="button silver block">キャンセル</router-link>
    </div>
  </div>
</template>å

<script>
import AuthApi from '../../api/auth'

export default {
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async handleClickResetPassword () {
      this.$validator.validateAll().then(async res => {
        if (res) {
          const loading = this.$loading.show({opacity: 0.5})
          try {
            await AuthApi.recoverPassword(this.email, 'sns')
            this.$message({message: 'メールアドレス宛にパスワード再設定通知を送りました', type: 'success'})
            this.$router.push({name: 'login'})
          } catch (e) {
            this.$message({message: '入力されたユーザーは存在しません', type: 'error'})
          }
          loading.hide()
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/screens/auth/forgot-password.vue